import { render, staticRenderFns } from "./Convocatorias.vue?vue&type=template&id=605534ae&scoped=true"
import script from "./Convocatorias.vue?vue&type=script&lang=js"
export * from "./Convocatorias.vue?vue&type=script&lang=js"
import style0 from "./Convocatorias.vue?vue&type=style&index=0&id=605534ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605534ae",
  null
  
)

export default component.exports